/* From Craft — made-to-measure product options.
   Renders option sets from fc-options.json and posts the choices as line item properties. */
(function () {
  var SWATCH_FIRST = 8; // swatches shown before "Load more"

  function money(sym, amount) {
    return sym + Math.round(amount).toLocaleString('en-ZA');
  }

  function matches(t, ptype, title) {
    if (!t) return false;
    var ti = (title || '').toLowerCase();
    var ty = (ptype || '').toLowerCase().trim();
    var hit = function (list) { return list.some(function (w) { return ti.indexOf(w) !== -1; }); };
    if (ty) {
      if (t.types && t.types.length) {
        if (t.types.indexOf(ty) === -1) return false;
      } else if (t.title && t.title.length) {
        if (!hit(t.title)) return false;
      } else {
        return false;
      }
    } else {
      if (!t.blank_title || !t.blank_title.length || !hit(t.blank_title)) return false;
    }
    if (t.title && t.title.length && t.types && t.types.length && !hit(t.title)) return false;
    if (t.not_title && t.not_title.length && hit(t.not_title)) return false;
    return true;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function build(root) {
    var ctx = {
      formId: root.dataset.formId,
      sym: root.dataset.currency || 'R',
      assetBase: root.dataset.assetBase || '',
      base: parseInt(root.dataset.price, 10) / 100
    };
    var title = root.dataset.productTitle || '';
    var ptype = root.dataset.productType || '';

    fetch(root.dataset.config)
      .then(function (r) { return r.json(); })
      .then(function (sets) {
        var set = sets.filter(function (s) { return matches(s.target, ptype, title); })[0];
        if (set) render(root, set, ctx);
      })
      .catch(function (e) { console.error('[fc-options]', e); });
  }

  function render(root, set, ctx) {
    root.innerHTML = '';
    var state = {};  // option label -> {value, price}
    var blocks = [];

    set.options.forEach(function (opt) {
      var box = el('div', 'fc-opt');
      box.dataset.optLabel = opt.label;

      if (!opt.hide_label && opt.label) {
        var lab = el('p', 'fc-opt__label', opt.label);
        if (opt.required) lab.appendChild(el('span', 'fc-opt__req', '*'));
        box.appendChild(lab);
      }

      if (opt.type === 'note') {
        if (opt.note) box.appendChild(el('p', 'fc-opt__note', opt.note));
        root.appendChild(box);
        blocks.push({ opt: opt, node: box });
        return;
      }

      var chosen = el('p', 'fc-opt__chosen', '');
      var name = 'properties[' + opt.label + ']';

      function pick(value, price) {
        state[opt.label] = { value: value, price: price || 0 };
        chosen.textContent = price ? value + '  (+' + money(ctx.sym, price) + ')' : value;
        sync();
      }

      if (opt.type === 'dropdown') {
        var sel = el('select', 'fc-opt__select');
        sel.name = name;
        sel.setAttribute('form', ctx.formId);
        if (opt.required) sel.required = true;
        sel.appendChild(new Option('-- please select --', ''));
        opt.values.forEach(function (v) {
          sel.appendChild(new Option(v.price ? v.label + '  (+' + money(ctx.sym, v.price) + ')' : v.label, v.label));
        });
        sel.addEventListener('change', function () {
          if (!sel.value) {
            delete state[opt.label];
            chosen.textContent = '';
            sync();
            return;
          }
          var v = opt.values.filter(function (x) { return x.label === sel.value; })[0];
          pick(sel.value, v ? v.price : 0);
        });
        box.appendChild(sel);
        box.appendChild(chosen);

      } else if (opt.type === 'swatch') {
        box.appendChild(chosen);
        var grid = el('div', 'fc-swatches');
        opt.values.forEach(function (v, i) {
          var lbl = el('label', 'fc-swatch');
          if (i >= SWATCH_FIRST) lbl.hidden = true;
          var input = el('input');
          input.type = 'radio';
          input.name = name;
          input.value = v.label;
          input.setAttribute('form', ctx.formId);
          var img;
          if (v.image) {
            img = el('img', 'fc-swatch__img');
            img.src = /^(https?:)?\/\//.test(v.image) ? v.image : ctx.assetBase + v.image;
            img.alt = v.label;
            img.loading = 'lazy';
          } else {
            img = el('span', 'fc-swatch__img fc-swatch__img--empty', v.label.slice(0, 2));
          }
          input.addEventListener('change', function () { pick(v.label, v.price); });
          lbl.appendChild(input);
          lbl.appendChild(img);
          lbl.appendChild(el('span', 'fc-swatch__name', v.label));
          grid.appendChild(lbl);
        });
        if (opt.values.length > SWATCH_FIRST) {
          var more = el('button', 'fc-swatches__more', 'Load more...');
          more.type = 'button';
          more.addEventListener('click', function () {
            Array.prototype.forEach.call(grid.querySelectorAll('.fc-swatch[hidden]'), function (n) { n.hidden = false; });
            more.remove();
          });
          grid.appendChild(more);
        }
        box.appendChild(grid);

      } else if (opt.type === 'checkbox') {
        var v0 = opt.values[0] || { label: 'Yes', price: 0 };
        var wrap = el('label', 'fc-check');
        var cb = el('input');
        cb.type = 'checkbox';
        cb.name = name;
        cb.value = v0.label;
        cb.setAttribute('form', ctx.formId);
        cb.addEventListener('change', function () {
          if (cb.checked) state[opt.label] = { value: v0.label, price: v0.price };
          else delete state[opt.label];
          sync();
        });
        wrap.appendChild(cb);
        wrap.appendChild(el('span', null, v0.price ? v0.label + '  (+' + money(ctx.sym, v0.price) + ')' : v0.label));
        box.appendChild(wrap);

      } else {
        var ta = el('textarea', 'fc-opt__textarea');
        ta.name = name;
        ta.setAttribute('form', ctx.formId);
        ta.rows = 3;
        ta.placeholder = 'Anything we should know — room size, fabric you already own, delivery notes.';
        box.appendChild(ta);
      }

      root.appendChild(box);
      blocks.push({ opt: opt, node: box });
    });

    // running total
    var total = el('div', 'fc-total');
    var rowBase = el('div', 'fc-total__row');
    rowBase.appendChild(el('span', null, 'Base price'));
    rowBase.appendChild(el('span', null, money(ctx.sym, ctx.base)));
    var rowExtras = el('div', 'fc-total__row');
    rowExtras.appendChild(el('span', null, 'Options'));
    var extrasVal = el('span', null, money(ctx.sym, 0));
    rowExtras.appendChild(extrasVal);
    var rowSum = el('div', 'fc-total__row fc-total__row--sum');
    rowSum.appendChild(el('span', null, 'Your price'));
    var sumVal = el('span', null, money(ctx.sym, ctx.base));
    rowSum.appendChild(sumVal);
    [rowBase, rowExtras, rowSum].forEach(function (r) { total.appendChild(r); });
    total.appendChild(el('p', 'fc-total__note',
      'Your choices are saved on the order. We confirm the final amount with you before we build.'));
    root.appendChild(total);

    var hidExtras = el('input');
    hidExtras.type = 'hidden';
    hidExtras.name = 'properties[Options total]';
    hidExtras.setAttribute('form', ctx.formId);
    root.appendChild(hidExtras);

    var err = el('p', 'fc-opts__error');
    err.hidden = true;
    root.appendChild(err);

    function sync() {
      blocks.forEach(function (b) {
        var cond = b.opt.show_if;
        if (!cond) return;
        var picked = state[cond.label];
        var show = !!picked && picked.value === cond.value;
        b.node.hidden = !show;
        if (!show && state[b.opt.label]) {
          delete state[b.opt.label];
          Array.prototype.forEach.call(b.node.querySelectorAll('input:checked'), function (i) { i.checked = false; });
          var c = b.node.querySelector('.fc-opt__chosen');
          if (c) c.textContent = '';
        }
        Array.prototype.forEach.call(b.node.querySelectorAll('input, select, textarea'), function (i) { i.disabled = !show; });
      });

      var extra = 0;
      Object.keys(state).forEach(function (k) { extra += state[k].price || 0; });
      extrasVal.textContent = (extra ? '+' : '') + money(ctx.sym, extra);
      sumVal.textContent = money(ctx.sym, ctx.base + extra);
      hidExtras.value = extra ? '+' + money(ctx.sym, extra) : '';
    }

    var form = document.getElementById(ctx.formId);
    if (form) {
      form.addEventListener('submit', function (e) {
        var missing = blocks.filter(function (b) {
          return b.opt.required && !b.node.hidden && !state[b.opt.label];
        });
        if (!missing.length) { err.hidden = true; return; }
        e.preventDefault();
        e.stopPropagation();
        err.hidden = false;
        err.textContent = 'Please choose: ' + missing.map(function (b) { return b.opt.label; }).join(', ');
        missing[0].node.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, true);
    }

    sync();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-fc-options]'), build);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
